import './bootstrap';
import 'lazysizes';
import Alpine from 'alpinejs';
import moment from "moment";
import Bugsnag from '@bugsnag/js';
import {setupTotal} from "./petition/setupTotal";
import {pollForNewEmails} from "./petition/pollForNewEmails";
import {setupEmailReactions} from "./petition/setupEmailReactions";
import {setupTabsEmail} from "./petition/setupTabsEmail";
import {writeMpForm} from "./petition/writeMPForm";
import {pollForNewComments} from "./petition/pollForNewComments";
import {signAndOptionForms} from "./petition/signAndOptionForms";
import {setupCommentReactions} from "./petition/setupCommentReactions";
import {setupProgress} from "./petition/setupProgressBar";
import {setupTabsComments} from "./petition/setupTabsComments";
import {setupHandraiserReactions} from "./petition/setupHandraiserReactions";
import {setupGenerateEmailContent} from "./petition/setupGenerateEmailContent";
import {handleCrowdFundForm} from "./petition/handleCrowdFundForm";
import {handleCustomFundraiseForm} from "./petition/handleCustomFundraiseForm";
import {trackFBShare, trackBlueSkyShare, trackEmailShare, trackWhatsAppShare, trackTwitterShare, copyToClipboard} from './petition/trackShares';
import suneditor from 'suneditor';
import { formatBlock, align, list, link, image, video } from 'suneditor/src/plugins'
window.SUNEDITOR = suneditor.init({
    plugins: [formatBlock, align, list, link, image, video]
});
import 'suneditor/dist/css/suneditor.min.css'

window.moment = moment;

if (import.meta.env.VITE_BUGSNAG_KEY) {
    Bugsnag.start(import.meta.env.VITE_BUGSNAG_KEY);
}

// Setup track shares
window.trackFBShare = trackFBShare;
window.trackBlueSkyShare = trackBlueSkyShare;
window.trackEmailShare = trackEmailShare;
window.trackWhatsAppShare = trackWhatsAppShare;
window.trackTwitterShare = trackTwitterShare;
window.copyToClipboard = copyToClipboard;

// START Setup functions used on petition/campaign pages
window.pollForNewEmails = pollForNewEmails;
window.setupTotal = setupTotal;
window.setupEmailReactions = setupEmailReactions;
window.setupTabsEmail = setupTabsEmail;
window.writeMpForm = writeMpForm;
window.pollForNewComments = pollForNewComments;
window.signAndOptionForms = signAndOptionForms;
window.setupCommentReactions = setupCommentReactions;
window.setupProgress = setupProgress;
window.setupTabsComments = setupTabsComments;
window.setupHandraiserReactions = setupHandraiserReactions;
window.setupGenerateEmailContent = setupGenerateEmailContent;
window.handleCrowdFundForm = handleCrowdFundForm;
window.handleCustomFundraiseForm = handleCustomFundraiseForm;
// END Setup functions used on petition/campaign pages

window.Alpine = Alpine;

Alpine.start();


